// src/pages/Home.jsx
import React, { useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { getMe } from "../services/authService";

const Home = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const checkLoginStatus = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const userInfo = await getMe();
          // ユーザーのロールに基づいて適切なページにリダイレクト
          if (userInfo.role === "admin") {
            navigate("/admin/users");
          } else if (userInfo.role === "teacher") {
            navigate("/teacher/video-upload");
          } else {
            navigate("/student/home");
          }
        } catch (err) {
          // トークンが無効な場合は、ローカルストレージからクリア
          localStorage.removeItem("token");
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    checkLoginStatus();
  }, [navigate]);

  // ロード中はローディングインジケータを表示
  if (loading) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container
      component="main"
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "calc(100vh - 64px)", // AppBar の高さを引いた分だけ
      }}
    >
      <Box>
        <Typography variant="h2" component="h1" gutterBottom>
          Co-Edu
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          AIと教員が協調して学生を支援するLMS
        </Typography>

  {/* LOGIN ボタン (登録は未実装のため非表示) */}
        <Box
          sx={{
            mt: 4,
            display: "flex",
            gap: 2,
            justifyContent: "center",
          }}
        >
          <Button variant="outlined" size="large" component={Link} to="/login">
            LOGIN
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Home;
